export default __webpack_public_path__ + "static/media/tiptoe.148de34f.png";